import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-center vh-90" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Network Graph", -1)
const _hoisted_3 = { class: "graph-control-panel container" }
const _hoisted_4 = {
  class: "btn-group pb-2",
  role: "group",
  "aria-label": "Download"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "text-center p-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "pb-0 mb-0" }, "Networks:", -1)
const _hoisted_8 = { style: {"list-style-type":"none"} }
const _hoisted_9 = ["onDblclick"]
const _hoisted_10 = ["r", "fill"]
const _hoisted_11 = ["font-size", "fill", "innerHTML"]
const _hoisted_12 = ["r", "stroke", "stroke-width"]
const _hoisted_13 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass('shadow border-secondary card rounded text-bg-dark z-3 position-absolute p-5 rounded-3 top-50 start-50 translate-middle w-50')
}
const _hoisted_14 = { class: "card-header position-relative" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "card-title text-center" }
const _hoisted_17 = { class: "card-subtitle mb-2 text-center" }
const _hoisted_18 = { class: "list-group border-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_network_graph = _resolveComponent("v-network-graph")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadAsSvg && _ctx.downloadAsSvg(...args)))
          }, "Download SVG"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadAsJson && _ctx.downloadAsJson(...args)))
          }, "Download JSON")
        ]),
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "range",
          class: "form-range w-50",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.zoomLevel) = $event)),
          min: "0.5",
          max: "2.0",
          step: "0.1"
        }, null, 512), [
          [_vModelText, _ctx.zoomLevel]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newdata.networks, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              style: {"display":"inline"},
              key: item
            }, [
              _createVNode(_component_font_awesome_icon, {
                color: item.color,
                icon: "fa-regular fa-circle"
              }, null, 8, ["color"]),
              _createTextVNode(" " + _toDisplayString(item.id + ' - ' + item.cidr_block), 1)
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_v_network_graph, {
        ref: "graph",
        class: "bg-dark bg-gradient graph w-100 networkgraph",
        nodes: _ctx.newdata.nodes,
        edges: _ctx.newdata.edges,
        configs: _ctx.newdata.configs,
        layouts: _ctx.newdata.layouts,
        "zoom-level": _ctx.zoomLevel
      }, {
        "override-node": _withCtx(({ nodeId, scale, config }) => [
          _createElementVNode("g", {
            onDblclick: ($event: any) => (_ctx.showNodeInfo(nodeId))
          }, [
            _createElementVNode("circle", _mergeProps({
              r: config.radius * scale,
              fill: config.color
            }, _ctx.newdata.nodes.slotProps), null, 16, _hoisted_10),
            _createElementVNode("text", {
              "font-family": "Material Icons",
              "font-size": config.radius * scale,
              fill: _ctx.newdata.nodes[nodeId].iconcolor,
              "text-anchor": "middle",
              "dominant-baseline": "central",
              style: {"pointer-events":"none"},
              innerHTML: _ctx.newdata.nodes[nodeId].icon
            }, null, 8, _hoisted_11),
            _createElementVNode("circle", {
              r: 80 * scale,
              fill: "none",
              stroke: _ctx.newdata.nodes[nodeId].networkcolor,
              "stroke-width": 2 * scale
            }, null, 8, _hoisted_12)
          ], 40, _hoisted_9)
        ]),
        default: _withCtx(() => [
          _createElementVNode("defs", null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent('style'), null, {
              default: _withCtx(() => [
                _createTextVNode(" @font-face { font-family: 'Material Icons'; font-style: normal; font-weight: 400; src: url(https://fonts.gstatic.com/s/materialicons/v97/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2) format('woff2'); } :root { background-color: #000; } ")
              ]),
              _: 1
            }))
          ])
        ]),
        _: 1
      }, 8, ["nodes", "edges", "configs", "layouts", "zoom-level"])
    ]),
    (_ctx.hoveredNodeId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              "aria-label": "Close",
              class: "btn btn-light rounded position-absolute top-0 start-100",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearNodeInfo()))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.newdata.nodes[_ctx.hoveredNodeId].rawdata.label), 1),
            _createElementVNode("h6", _hoisted_17, _toDisplayString(_ctx.newdata.nodes[_ctx.hoveredNodeId].rawdata.endpoint_type.toUpperCase()), 1),
            _createElementVNode("ul", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newdata.nodes[_ctx.hoveredNodeId].rawdata, (item, key) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: key,
                  class: "list-group-item list-group-item-dark border-0 lh-1 p-1"
                }, _toDisplayString(key) + ": " + _toDisplayString(item ?? 'null'), 1))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}